<template>
  <div>
    <TableHeaderCellDropdown @clear="onClear"
                             @open="load">
      <template v-slot:trigger-text>
        {{ $tResumesBaseInteraction('Interaction step') }}
      </template>
      <template v-if="selectedItems.length"
                v-slot:selected>
        <span class="table-header-cell-dropdown__selected-text">
          {{ selectedItems.length }}
        </span>
      </template>
      <template v-slot:content="">
        <div class="table-header-cell-dropdown__options  filter-checkbox">
          <BasePreloader v-if="pending"/>
          <ul class="filter-checkbox__list">
            <li v-for="item in items"
                :key="item.key"
                class="filter-checkbox__item">
              <BaseCheckbox :label="$tResumesBaseInteraction(item.name)"
                            :checked="selectedIds.includes(String(item.key))"
                            @input="onChange($event, item.key)"/>
            </li>
          </ul>
        </div>
      </template>
    </TableHeaderCellDropdown>
  </div>
</template>

<script>
  import TableHeaderCellDropdown from '@/components/TableHeaderCellDropdown'
  import {http} from "@/axios"

  export default {
    name: 'APResumesBaseInteractionsPageHeadRowStage',
    components: {
      TableHeaderCellDropdown
    },
    props: {
      routeKey: String,
      apiLink: String,
    },
    data() {
      return {
        items: null,
        pending: false,
        loaded: false,
      }
    },
    computed: {
      selectedIds() {
        const candidates = this.$route.query[this.routeKey] || []
        return Array.isArray(candidates) ? candidates : [candidates]
      },
      selectedItems() {
        const ids = this.selectedIds
        return (this.items || []).filter(item => ids.includes(String(item.key)))
      }
    },
    methods: {
      load() {
        if (this.loaded || this.pending) return

        this.pending = true

        http.get(this.apiLink)
            .then(({data}) => {
              this.items = data.data
              this.loaded = true
            })
            .finally(() => {
              this.pending = false
            })
      },
      onChange(value, id) {
        let ids = [...this.selectedIds]

        if (value) {
          ids.push(String(id))
        } else {
          ids = ids.filter(i => i !== String(id))
        }

        const query = {
          ...this.$route.query,
        }

        if (ids.length) {
          query[this.routeKey] = ids
        } else {
          delete query[this.routeKey]
        }

        this.$router.push({
          query
        }).catch(() => ({}))
      },
      onClear() {
        const query = {
          ...this.$route.query,
        }

        delete query[this.routeKey]

        this.$router.push({
          query
        }).catch(() => ({}))
      },
    }
  }
</script>

<style>

</style>
